import { List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

interface IEntitlementConditions {
  conditions: string[];
}

export const EntitlementConditions = ({
  conditions,
}: IEntitlementConditions) => {
  const isDesktop = useIsDesktop();

  const listStyle = {
    listStyle: 'none',
    '&::before': {
      content: "'•'",
      color: '#526A83',
      fontSize: isDesktop ? '25px' : '30px',
      margin: '4px 8px auto 0',
    },
    padding: 0,
  };

  return (
    <Stack direction='column' gap='8px' margin='0 0 30px 0'>
      <Typography variant={'body1'} component='h2'>
        {Dictionary[DICTIONARY.CompassRights].entitlements.conditions}
      </Typography>
      <List sx={{ padding: 0 }}>
        {conditions?.map((condition: string, index: number) => {
          return (
            <ListItem sx={listStyle} key={index}>
              <ListItemText
                primary={condition}
                primaryTypographyProps={{ variant: 'body3' }}
              />
            </ListItem>
          );
        })}
      </List>
    </Stack>
  );
};
